// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__LKIPg","searchTextBox":"SearchBar_searchTextBox__bEcgk","searchIcon":"SearchBar_searchIcon__L36Lk"};